import React, { useState, useEffect, useCallback, useRef } from "react"
import { useParams, useHistory } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/Search'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import SelectOption from "@base/Inputs/Select"
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Filters from '@base/Filter'
import TextField from '@base/Inputs/Text'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import TratarDiscrepanciaDialog from '@pages/Escola/TratarDiscrepanciaDialog'

import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import DocumentoEnvioService from "@services/DocumentoEnvioService"

import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'

import useUfs from '@hooks/enums/useUfs';

export const TratamentoDiscrepanciaDE = () => {
  const params = useParams();
  let processo = ProcessoResolver(params.processo);

  const [loading, setLoading] = useState(true);

  const [list, setList] = useState([]);

  const listagemUF = useUfs(processo.id)

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('escola.nome')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
	const [documentoEnvioSelecionado, setDocumentoEnvioSelecionado] = useState("");
  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroUF, setFiltroUF] = useState('');
  const [filtroInep, setFiltroInep] = useState();
  const [filtroNomeEscola, setFiltroNomeEscola] = useState();
	const [openDialogTratamentoDiscrepancia, setOpenDialogTratamentoDiscrepancia] = useState(false);
  const [,setHoraUltimoRefresh] = useState();
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);



  const history = useHistory();

  const toastRef = useRef(null);
  const filtroRef = useRef(null);
  function redirecionarParaPaginaDoDE(codigoInep) {
    history.push({ pathname: "/" + params.processo + "/escola/" + codigoInep + "/de/ENVELOPE", state: { codigoInep: codigoInep }, });
  }

  function redirecionarParaPaginaDeCartoes(codigoInep) {
    history.push("/" + params.processo + "/escola/" + codigoInep + "/cartoes");
  }

  const aplicarFiltros = useCallback((ativo = false) => {
    let f = [];

    if (filtroNomeEscola) f.push({ field: 'nome', value: filtroNomeEscola });
    if (filtroInep) f.push({ field: 'inep', value: filtroInep });
    if (filtroUF) f.push({ field: 'uf', value: filtroUF });

    setFiltros(f);
    setFiltroAtivo(ativo);
    setQuantidadeFiltrosAplicados(f.length);
  },[filtroNomeEscola, filtroInep, filtroUF])

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }])
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroNomeEscola('');
    setFiltroInep('');
    setFiltroUF('');

    setQuantidadeFiltrosAplicados(0);
  }

  const aplicarFormatacaoNumeros = (qtdeCartoes, qtdeCartoesRecebidos, tratamentoDiscrepanciaStatus) => {
    const temDiscrepancia = parseInt(qtdeCartoes) > parseInt(qtdeCartoesRecebidos) && tratamentoDiscrepanciaStatus !== "RESOLVIDA";

    return (
      <span 
        style={{ 
          padding: 5, 
          borderRadius: 20, 
          backgroundColor: temDiscrepancia ? "#d9746c" : null, 
          color: temDiscrepancia ? "white" : null 
        }}
      >
        {qtdeCartoes}/{qtdeCartoesRecebidos}
      </span>
    )
  }

  const aplicarFormatacaoStatus = (status, responsavel) => {
    return <>{status ?? ""} {responsavel && <span style={{ display: "block", color: "#999", fontSize: 11 }} >{responsavel}</span>}</>
  }

  const columns = [
    { label: 'Codigo', name: 'inep', filter: 'escola.codigoInep', func: null, key: true },
    { label: 'Nome', name: 'escola', filter: 'escola.nome',  func: null, key: false },
    { label: 'Nível 1', name: 'qtdeCartoesN1', func: (c, l) => aplicarFormatacaoNumeros(l.qtdMaxPermitidaSegundaFaseN1, l.qtdeCartoesN1Recebidos, l.tratamentoDiscrepanciaStatus), key: false },
    { label: 'Nível 2', name: 'qtdeCartoesN2', func: (c, l) => aplicarFormatacaoNumeros(l.qtdMaxPermitidaSegundaFaseN2, l.qtdeCartoesN2Recebidos, l.tratamentoDiscrepanciaStatus), key: false },
    { label: 'Nível 3', name: 'qtdeCartoesN3', func: (c, l) => aplicarFormatacaoNumeros(l.qtdMaxPermitidaSegundaFaseN3, l.qtdeCartoesN3Recebidos, l.tratamentoDiscrepanciaStatus), key: false },
	  { label: 'Status do Tratamento',	name: 'tratamentoDiscrepanciaStatus',func: (c, l) => aplicarFormatacaoStatus(l.tratamentoDiscrepanciaStatus, l.tratamentoDiscrepanciaResponsavel), key: false },
    { label: 'Observações',	name: 'tratamentoDiscrepanciaDescricao', func: null, key: false }
];

  const actions = [
    {
      name: () => "Listar Cartões",
      func: redirecionarParaPaginaDeCartoes,
      icon: <LibraryBooksIcon />,
      disabled: () => false,
    },
    {
      name: () => "Visualizar Documento Envio",
      func: redirecionarParaPaginaDoDE,
      icon: <SearchIcon />,
      disabled: () => false,
    },{
			name: () => "Tratar Discrepância",
			func: (id,l) => { console.log(list);console.log(id); setDocumentoEnvioSelecionado(list.find(c => c.id === l.id)); setOpenDialogTratamentoDiscrepancia(true); },
			icon: <AssignmentTurnedInIcon />,
			disabled: (id) => {

				return false;
			},
		}

  ]

  const carregarDados = useCallback(() => {
    const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);

    f.push({ field: 'comDiscrepanciaEntreDECartoes', value: true });

    setLoading(true);
    DocumentoEnvioService.filtrar(processo.id, f).then(resultado => {
      const { content, number, size, totalElements, totalPages } = resultado.data;
      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar Filtros!"));

  }, [filtros, filtroAtivo, page, size, sort, processo.id]);


  const handlePage = page => { setPage(page); setFiltroAtivo(true); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };
  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
    setFiltroAtivo(true);
  }
  const handleClearSort = (orderBy) => { setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  useEffect(() => carregarDados(), [carregarDados]);

  useEffect(() => {

    if(filtroInep && filtroInep.length === 16) {
      aplicarFiltros(true);
      filtroRef.current.closeFilters();
    }

  }, [filtroInep, aplicarFiltros]);


  return (
    <>
      <Toast ref={toastRef} />

      <Title>Tratamento de Discrepância de D.E.</Title><br />

      <Filters
        open={true}
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
        ref={filtroRef}>
        <Grid item container spacing={3}>
          <Grid item sm={2} lg={2}>
            <TextField
              autoFocus
              label='INEP ou Código do Cartão'
              value={filtroInep}
              name='filtroInep'
              inputProps={{ maxLength: 16 }}
              onChange={(e) => setFiltroInep(e.target.value.trim())} />
          </Grid>
          <Grid item sm={4} lg={4}>
            <TextField
              label='Nome da Escola'
              value={filtroNomeEscola}
              name='filtroNomeEscola'
              onChange={(e) => setFiltroNomeEscola(e.target.value)} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='UF'
              value={filtroUF}
              name='filtroUF'
              onChange={(e) => setFiltroUF(e.target.value)}
              options={listagemUF.data} />
          </Grid>
        </Grid>
      </Filters>

	 <Grid container spacing={3} style={{ marginTop: '10px', marginBottom: '-76px' }}>
        <Grid item sm={12} lg={12}>
          <b>Legenda: </b>
         	Quantitativo do DE / Cartões Recebidos
        </Grid>
      </Grid>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
        rowsPerPageOptions={[3, 5, 10, 25, 50, 100]}
		disableRowWhen={(obj) => obj.status === "INVALIDA" || obj.status === "DESCLASSIFICADA"}
      />


	{openDialogTratamentoDiscrepancia &&
		<TratarDiscrepanciaDialog
			handleSave={(resultado)=>{
				setHoraUltimoRefresh(new Date());
				setOpenDialogTratamentoDiscrepancia(false);
			}}
			processo={processo}
			documentoEnvio={documentoEnvioSelecionado}
			handleClose={() => setOpenDialogTratamentoDiscrepancia(false)}
			toastReference={toastRef}
			open={openDialogTratamentoDiscrepancia} />}

    </>
  );
}

export default TratamentoDiscrepanciaDE;
